import { gql } from '@parkchirp/api-client';

export const LIST_RESERVED_SPACE_INVENTORY = gql`
	query listReservedSpaceInventory($limit: Int!, $offset: Int!, $filters: [Filter], $order: SortOrder, $facilityId: String!) {
		listReservedSpaceInventory(limit: $limit, offset: $offset, filters: $filters, order: $order, facilityId: $facilityId) {
			count,
			reservedSpaces {
				id
				spaceNumber
				quantity
				level
				type
				sublot {
					id
					name
				}
				available
			}
		}
	}
`;

export const LIST_RESERVED_SPACE_INVENTORY_CSV = gql`
	query listReservedSpaceInventoryCSV($filters: [Filter], $order: SortOrder, $facilityId: String!) {
		listReservedSpaceInventoryCSV(filters: $filters, order: $order, facilityId: $facilityId) {
		url
	}
}
`;

export const LIST_ALL_RESERVED_SPACES = gql`
	query listAllReservedSpaces($limit: Int!, $offset: Int!, $filters: [Filter], $order: SortOrder) {
		listAllReservedSpaces(limit: $limit, offset: $offset, filters: $filters, order: $order) {
			count,
			reservedSpaces {
				id
				createdAt
				parkerId
				firstName
				lastName
				email
				accountId
				subscriptionId
				subscriptionName
				payorType
				readableId
				facilityId
				facilityName
				facilityNumber
				active
				inactive
				reservedSpaceInventoryId
				spaceNumber
				level
				reservedSpaceInventoryType
				quantity
				sublotId
				sublotName
			}
		}
	}
`;

export const LIST_ALL_RESERVED_SPACES_CSV = gql`
	query listAllReservedSpacesCSV($filters: [Filter], $order: SortOrder) {
		listAllReservedSpacesCSV(filters: $filters, order: $order) {
			url
		}
	}
`;

export const CREATE_RESERVED_SPACE = gql`
	mutation createReservedSpace($input: CreateReservedSpaceInput!) {
		createReservedSpace(input: $input)
	}
`;

export const UPDATE_RESERVED_SPACE = gql`
	mutation updateReservedSpace($input: UpdateReservedSpaceInput!) {
		updateReservedSpace(input: $input)
	}
`;

export const GET_AVAILABLE_RESERVED_SPACE_INVENTORY_BY_SUBLOT = gql`
	query getAvailableReservedSpaceInventoryBySublot($input: GetAvailableReservedSpaceInventoryBySublotInput!) {
		getAvailableReservedSpaceInventoryBySublot(input: $input) {
			reservedSpaces {
				id
				spaceNumber
				level
			}
		}
	}
`;

export const GET_PARKER_RESERVED_SPACES = gql`
	query getParkerReservedSpaces($parkerId: String!) {
		getParkerReservedSpaces(parkerId: $parkerId) {
			count,
			reservedSpaces {
				id
				reservedSpaceId
				spaceNumber
				level
				active
				inactive
			}
		}
	}
`;

export const DELETE_RESERVED_SPACE = gql`
	mutation deleteReservedSpace($input: DeleteReservedSpaceInput!) {
		deleteReservedSpace(input: $input)
	}
`;
